import React, { Component } from 'react'
import { connect } from 'react-redux'
import './CompText.css'
import i18n from '../../../i18n'

class CompText extends Component {
  render() {
    const { earningsAggs } = this.props

    if (earningsAggs) {
      return (
        <div className='earnings-disclosure'>
          <div className='disclosure'>{i18n.t('periodicity-def')}</div>
          <br />
          <div className='disclosure'>{i18n.t('earnings-surprise-def')}</div>
          <br />
          <div className='disclosure'>{i18n.t('sales-surprise-def')}</div>
          <br />
          <div className='disclosure'>{i18n.t('earnings-growth-def')}</div>
          <br />
          <div className='disclosure'>{i18n.t('sales-growth-def')}</div>
        </div>
      )
    } else return null
  }
}

function mapStateToProps(state) {
  return {
    earningsAggs: state.data.earningsAggs
  }
}

export default connect(mapStateToProps, {})(CompText)



// WEBPACK FOOTER //
// ./src/components/App/Compliance/CompText.js